module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-02-b 14.858b3303.png";